/** Plan picked on the marketing site's pricing table, kept until the user upgrades or dismisses it. */
export type PlanIntent = "pro" | "business";
const KEY = "df.planIntent";

export function rememberPlanIntent(plan: PlanIntent | undefined) {
  if (!plan) return;
  try {
    localStorage.setItem(KEY, plan);
  } catch {
    // Storage may be unavailable (private mode); the intent is a convenience only.
  }
}

export function planIntent(): PlanIntent | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === "pro" || v === "business" ? v : null;
  } catch {
    return null;
  }
}

export function clearPlanIntent() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
